import {createTheme} from "@material-ui/core/styles";

// PaletteOptions 타입 확장
declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    input: {
      light: string;
      main: string;
      dark: string;
    };
  }

  // Optional: palette 옵션에서 추가할 속성을 정의
  interface PaletteOptions {
    input?: {
      light: string;
      main: string;
      dark: string;
    };
  }
  interface Palette {
    custom: {
      light: string;
      main: string;
      dark: string;
    };
  }

  // Optional: palette 옵션에서 추가할 속성을 정의
  interface PaletteOptions {
    custom?: {
      light: string;
      main: string;
      dark: string;
    };
  }
  interface Palette {
    gray: {
      light: string;
      main: string;
      dark: string;
    };
  }

  // Optional: palette 옵션에서 추가할 속성을 정의
  interface PaletteOptions {
    gray?: {
      light: string;
      main: string;
      dark: string;
    };
  }
}
declare module "@material-ui/core/styles/createPalette" {}

export const Theme = (darkMode: boolean) =>
  createTheme({
    palette: {
      type: darkMode ? "dark" : "light",
      primary: {
        light: darkMode ? "#7986cb" : "#8c9eff",
        main: darkMode ? "#758afe" : "#536dfe",
        dark: darkMode ? "#828bc5" : "#304ffe",
      },
      secondary: {
        light: darkMode ? "#bcaaa4" : "#d7ccc8",
        main: darkMode ? "#8d6e63" : "#795548",
        dark: darkMode ? "#5d4037" : "#4e342e",
      },
      error: {
        light: darkMode ? "#ff8a65" : "#ff8a80",
        main: darkMode ? "#ff5722" : "#ff5252",
        dark: darkMode ? "#f4511e" : "#ff1744",
      },
      info: {
        light: darkMode ? "#80deea" : "#82b1ff",
        main: darkMode ? "#00bcd4" : "#448aff",
        dark: darkMode ? "#dbdce0" : "#545556",
      },
      success: {
        light: darkMode ? "#54c28c" : "#546342",
        main: darkMode ? "#3b7f01" : "#00e676",
        dark: darkMode ? "#234c00" : "#66de97",
      },
      warning: {
        light: darkMode ? "#ffd740" : "#ffd180",
        main: darkMode ? "#ffc400" : "#ffab40",
        dark: darkMode ? "#ffab00" : "#ff9100",
      },
      input: {
        light: darkMode ? "#424242" : "#f5f5f5",
        main: darkMode ? "#303030" : "#fff",
        dark: darkMode ? "#212121" : "#e0e0e0",
      },
      background: {
        default: darkMode ? "#262626" : "#fafafa",
        paper: darkMode ? "#2a2a2a" : "#ffffff",
      },
      text: {
        primary: darkMode ? "#ffffff" : "rgba(0, 0, 0, 0.87)",
        secondary: darkMode ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.6)",
        disabled: darkMode ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.38)",
        hint: darkMode ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.38)",
      },
      gray: {
        light: darkMode ? "#4f4f4f" : "#f6f8f8",
        main: darkMode ? "#3f3f3f" : "#f6f8f8",
        dark: darkMode ? "#262626" : "#fff",
      },
      custom: {
        light: darkMode ? "#3e3e3e" : "#f8f9fa",
        main: darkMode ? "#282828" : "#ffff",
        dark: darkMode ? "#1b1b1b" : "#e8eaed",
      },
    },
    typography: {
      fontFamily: ["Roboto", "Pretendard", "Noto Sans KR"].join(","),
    },
  });

// export const Theme = (darkMode: boolean) =>
// createTheme({
//   palette: {
//     type: darkMode ? "dark" : "light",

//     primary: {
//       light: darkMode ? "#83abe5" : "#92beff",
//       main: darkMode ? "#97b0d4" : "#267dff",
//       dark: darkMode ? "#8194ae" : "#1850a3",
//     },
//     secondary: {
//       light: brown[300],
//       main: brown[400],
//       dark: brown[600],
//     },
//     error: {
//       light: "#e57373",
//       main: "#f44336",
//       dark: "#d32f2f",
//     },
//     info: {
//       light: "#80deea",
//       main: "#00bcd4",
//       dark: "#00838f",
//     },
//     success: {
//       light: "#7986cb",
//       main: "#3f51b5",
//       dark: "#283593",
//     },
//     warning: {
//       light: "#dbdce0",
//       main: "#9e9e9e",
//       dark: "#4f5470",
//     },
//     input: {
//       light: darkMode ? "#484848" : "#e9e9ea",
//       main: "#e9e9ea",
//       dark: "#484848",
//     },

//     background: {
//       default: darkMode ? "#191e20" : "#fafafa", // Dark mode에서 배경
//       paper: darkMode ? "#252b2e" : "#ffffff", // 카드 등의 배경
//     },

//     text: {
//       primary: darkMode ? "#ffffff" : "rgba(0, 0, 0, 0.87)", // 다크모드에서는 텍스트가 하얀색
//       secondary: darkMode ? "#b0b0b0" : "rgba(0, 0, 0, 0.54)", // 서브텍스트
//       disabled: "rgba(0, 0, 0, 0.38)",
//       hint: "rgba(0, 0, 0, 0.38)",
//     },

//     custom: {
//       light: darkMode ? "#4b5153" : "#ededee",
//       main: darkMode ? "#384348" : "#e9e9ea",
//       dark: darkMode ? "#1f2428" : "#e8e8e8",
//     },
//   },

//   typography: {
//     fontFamily: ["Roboto", "Pretendard", "Noto Sans KR"].join(","),
//   },
// });
